import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appRibbonToolbarContent]'
})
export class RibbonToolbarContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
